<div class="overlay">
  <div class="modal">
    <main
      id="main_modal_content"
      class="bg-white rounded-xl shadow-xl w-full max-w-3xl overflow-hidden border border-neutral-200"
    >
      <header id="header" class="flex justify-between items-center p-6 pb-0">
        <div id="tabs_navigation" class="flex items-center space-x-8">
          <button
            class="text-sm text-neutral-500 border-neutral-900 pb-4 transition-all duration-200"
            [ngClass]="{ 'border-b-2': stepForm === 1 }"
          >
            INFORMAÇÕES
          </button>
          <button
            class="text-sm text-neutral-500 border-neutral-900 pb-4 transition-all duration-200 relative group"
            [ngClass]="{ 'border-b-2': stepForm === 2 }"
          >
            VARIAVEIS E BOTOES
            <span
              class="absolute bottom-0 left-0 w-0 h-0.5 bg-neutral-300 group-hover:w-full transition-all duration-200"
            ></span>
          </button>
          <button
            class="text-sm text-neutral-500 border-neutral-900 pb-4 transition-all duration-200 relative group"
            [ngClass]="{ 'border-b-2': stepForm === 3 }"
          >
            CANAIS
            <span
              class="absolute bottom-0 left-0 w-0 h-0.5 bg-neutral-300 group-hover:w-full transition-all duration-200"
            ></span>
          </button>
          <button
            class="text-sm text-neutral-500 border-neutral-900 pb-4 transition-all duration-200 relative group"
            [ngClass]="{ 'border-b-2': stepForm === 4 }"
          >
            AGENDAMENTOS
            <span
              class="absolute bottom-0 left-0 w-0 h-0.5 bg-neutral-300 group-hover:w-full transition-all duration-200"
            ></span>
          </button>
        </div>
        <button
          id="close_button"
          aria-label="Close modal"
          class="text-neutral-400 hover:text-neutral-600 hover:bg-neutral-100 rounded-full p-2 transition-all duration-200"
          (click)="handleCloseModal(1)"
        >
          <i class="fa-solid fa-xmark fa-lg"></i>
        </button>
      </header>

      <section id="form_section" class="p-8 pt-6 overflow-y-auto">
        <div [ngClass]="stepForm === 1 ? 'block' : 'hidden'">
          <form id="import_form" class="space-y-4" [formGroup]="formOficialCsv">
            <div id="file_upload_block" class="space-y-3">
              <label class="block text-sm text-neutral-800"
                >Importar contatos
                <span class="text-neutral-500">*</span></label
              >
              <div class="relative group">
                <div
                  class="flex items-center w-full border-2 border-dashed border-neutral-300 rounded-xl hover:border-neutral-400 focus-within:border-neutral-900 transition-all duration-200 bg-neutral-50/50"
                >
                  <label
                    for="file_input_trigger"
                    class="cursor-pointer bg-gradient-to-r from-neutral-100 to-neutral-50 text-neutral-700 py-3 px-6 rounded-l-xl border-r border-neutral-300 hover:from-neutral-200 hover:to-neutral-100 transition-all duration-200"
                  >
                    <i class="fa-solid fa-upload mr-2"></i>Escolher arquivo
                  </label>
                  <input
                    id="file_input_trigger"
                    type="file"
                    class="sr-only"
                    accept=".csv"
                    (change)="handleAddCsvFile($event)"
                  />
                  <span class="pl-4 text-sm text-neutral-500 truncate flex-1"
                    >@if (fileName.length > 0) {
                    {{ fileName }}
                    }@else {
                    {{ "Selecione um arquivo" }}
                    }
                  </span>
                </div>
                <br />
                <label class="block text-sm text-neutral-800"
                  >Arquivo de Midia
                  <span class="text-neutral-500">*</span></label
                >
                <div
                  class="flex items-center w-full border-2 border-dashed border-neutral-300 rounded-xl hover:border-neutral-400 focus-within:border-neutral-900 transition-all duration-200 bg-neutral-50/50"
                >
                  <label
                    for="file_input_midia"
                    class="cursor-pointer bg-gradient-to-r from-neutral-100 to-neutral-50 text-neutral-700 py-3 px-6 rounded-l-xl border-r border-neutral-300 hover:from-neutral-200 hover:to-neutral-100 transition-all duration-200"
                  >
                    <i class="fa-solid fa-upload mr-2"></i>Escolher arquivo
                  </label>
                  <input
                    id="file_input_midia"
                    type="file"
                    class="sr-only"
                    accept=".jpeg"
                    (change)="onFilesSelected($event)"
                  />
                  <span class="pl-4 text-sm text-neutral-500 truncate flex-1"
                    >@if (fileNameMidia.length > 0) {
                    {{ fileNameMidia }}
                    }@else {
                    {{ "Selecione um arquivo" }}
                    }
                  </span>
                </div>
              </div>
              <p class="text-xs text-neutral-600 flex items-center">
                <i class="fa-solid fa-info-circle mr-2 text-neutral-400"></i
                >Apenas arquivos CSV são aceitos
              </p>
            </div>

            <div
              id="ignore_line_block"
              class="flex items-center p-2 bg-neutral-50 rounded-lg border border-neutral-200"
            >
              <input
                formControlName="ignoreRow"
                id="ignore_first_line"
                type="checkbox"
                class="h-4 w-4 text-neutral-900 border-neutral-300 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200"
              />
              <label
                for="ignore_first_line"
                class="ml-3 block text-sm text-neutral-800"
                >Ignorar primeira linha do arquivo</label
              >
            </div>
            <div class="grid grid-cols-1 gap-6">

              <div id="template_id_block" class="space-y-3">
                <label for="template_id" class="block text-sm text-neutral-800"
                >Nome da Campanha <span class="text-neutral-500">*</span></label
                >
                <div class="relative">
                  <input
                    formControlName="campanha"
                    type="text"
                    id="template_id"
                    placeholder="Digite o nome da campanha"
                    class="w-full px-4 py-3 border border-neutral-300 rounded-lg placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 bg-white hover:border-neutral-400"
                  />
                </div>
                <p class="text-xs text-neutral-600">Nome da Campanha</p>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div id="template_id_block" class="space-y-3">
                <label for="template_id" class="block text-sm text-neutral-800"
                  >Template ID <span class="text-neutral-500">*</span></label
                >
                <div class="relative">
                  <input
                    formControlName="idTemplate"
                    type="number"
                    id="template_id"
                    placeholder="Digite o template ID"
                    class="w-full px-4 py-3 border border-neutral-300 rounded-lg placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 bg-white hover:border-neutral-400"
                  />
                  <i
                    class="fa-solid fa-hashtag absolute right-10 top-3.5 text-neutral-400"
                  ></i>
                </div>
                <p class="text-xs text-neutral-600">ID da mensagem template</p>
              </div>

              <div id="phone_column_block" class="space-y-3">
                <label for="phone_column" class="block text-sm text-neutral-800"
                  >Coluna do Telefone
                  <span class="text-neutral-500">*</span></label
                >
                <div class="relative">
                  <select
                    formControlName="colunaTelefone"
                    id="phone_column"
                    class="w-full appearance-none bg-white border border-neutral-300 rounded-lg px-4 py-3 pr-10 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                  >
                    <option value="" disabled selected>
                      Selecione uma coluna
                    </option>
                    <option
                      *ngFor="let column of columns"
                      [value]="column.value"
                    >
                      {{ column.column }}
                    </option>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500"
                  >
                    <i class="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                <p class="text-xs text-neutral-600">
                  Coluna com números de telefone
                </p>
              </div>
            </div>

            <footer
              id="footer"
              class="flex justify-end items-center p-6 bg-gradient-to-r from-neutral-50 to-white border-t border-neutral-200 space-x-4"
            >
              <button
                (click)="handleCloseModal(1)"
                id="cancel_button"
                type="button"
                class="px-6 py-2.5 text-sm text-neutral-700 bg-white border border-neutral-300 rounded-lg shadow-sm hover:bg-neutral-50 hover:border-neutral-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-500 transition-all duration-200"
              >
                CANCELAR
              </button>
              <button
                (click)="nextStep()"
                [disabled]="!handleValidStepOne()"
                id="continue_button"
                type="submit"
                class="px-6 py-2.5 text-sm text-white button-send from-neutral-900 to-neutral-800 border border-transparent rounded-lg shadow-sm hover:from-neutral-800 hover:to-neutral-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-900 transition-all duration-200"
              >
                <i class="fa-solid fa-arrow-right mr-2"></i>CONTINUAR
              </button>
            </footer>
          </form>
        </div>

        <div [ngClass]="stepForm === 2 ? 'block' : 'hidden'">
          <form id="import_form" class="space-y-8" [formGroup]="formOficialCsv">
            <section
              id="channels_section"
              class="p-6 flex-grow bg-neutral-50/50"
            >
              <div class="space-y-6">
                <!-- ===================== VARIÁVEIS ===================== -->
                <div
                  class="rounded-xl border border-neutral-200 bg-white shadow-sm"
                >
                  <div
                    class="flex items-center justify-between gap-3 border-b border-neutral-100 px-4 py-3"
                  >
                    <h3 class="text-sm font-medium text-neutral-800">
                      Variáveis
                    </h3>
                    <small class="text-xs text-neutral-500 hidden md:block">
                      Devem obedecer a sequência do template cadastrado no
                      gestor.
                    </small>
                  </div>

                  <!-- Toolbar de variáveis -->
                  <div class="px-4 py-4">
                    <div
                      class="flex flex-col lg:flex-row lg:items-center gap-3"
                    >
                      <select
                        (change)="handleChangeOptionSelectedAddVariable($event)"
                        name="optionSelectedAddVariable"
                        class="w-full lg:w-64 rounded-lg border border-neutral-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
                      >
                        <option value="" disabled selected>
                          Selecione uma variável…
                        </option>
                        <option
                          *ngFor="let column of columns"
                          [value]="column.value"
                        >
                          {{ column.column }}
                        </option>
                      </select>

                      <div class="flex flex-wrap items-center gap-2">
                        <button
                          type="button"
                          (click)="handleAddVariableInTemplate()"
                          class="inline-flex items-center rounded-lg border border-transparent px-4 py-2 text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                          + Adicionar variável
                        </button>

                        <button
                          type="button"
                          (click)="handleClearAllVariables()"
                          class="inline-flex items-center rounded-lg px-4 py-2 text-sm font-medium bg-neutral-100 text-neutral-700 hover:bg-neutral-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Limpar tudo
                        </button>
                      </div>
                    </div>

                    <small
                      class="mt-2 block w-full text-xs text-neutral-500 whitespace-normal break-words leading-snug lg:hidden"
                    >
                      Assim como nos templates, as variáveis aqui adicionadas
                      terão de obedecer a sequência do template cadastrado no
                      gestor.
                    </small>
                  </div>

                  <!-- Lista das variáveis (chips) -->
                  <div class="px-4 pb-4">
                    <div
                      class="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-48 overflow-y-auto pr-2"
                    >
                      <div
                        class="flex items-center justify-between gap-2 rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2"
                        *ngFor="
                          let variable of referedVariables.controls;
                          index as i
                        "
                      >
                        <span
                          class="text-sm font-medium text-neutral-700 truncate"
                        >
                          {{ getTraductionColumn(variable.value) }}
                        </span>
                        <button
                          type="button"
                          aria-label="Remover variável"
                          class="rounded-md px-3 py-1.5 text-xs font-medium bg-rose-100 text-rose-700 hover:bg-rose-200"
                          (click)="handleRemoveVariable(i)"
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ===================== BOTÕES ===================== -->
                <!-- <div
                  class="rounded-xl border border-neutral-200 bg-white shadow-sm"
                  disabled="true"
                >
                  <div
                    class="flex items-center justify-between gap-3 border-b border-neutral-100 px-4 py-3"
                  >
                    <h3 class="text-sm font-medium text-neutral-800">Botões</h3>

                    <button
                      type="button"
                      (click)="handleClearButtons()"
                      class="inline-flex items-center rounded-lg px-3 py-1.5 text-sm font-medium bg-neutral-100 text-neutral-700 hover:bg-neutral-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Limpar Botões
                    </button>
                  </div>


                  <div class="px-4 py-4" >
                    <div class="flex flex-wrap items-center gap-2">
                      <button
                        type="button"
                        (click)="handleAddButtonInTemplate('normal')"
                        class="inline-flex items-center rounded-lg border border-transparent px-4 py-2 text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60"
                        [disabled]="isButtonConfigured()"
                        [ngClass]="{
                          'cursor-not-allowed': isButtonConfigured()
                        }"
                      >
                        + Adicionar Botão Normal
                      </button>

                      <button
                        type="button"
                        (click)="handleAddButtonInTemplate('lista')"
                        class="inline-flex items-center rounded-lg border border-transparent px-4 py-2 text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60"
                        [disabled]="isButtonConfigured()"
                        [ngClass]="{
                          'cursor-not-allowed': isButtonConfigured()
                        }"
                      >
                        + Adicionar Lista
                      </button>

                      <button
                        type="button"
                        (click)="handleAddButtonInTemplate('url')"
                        class="inline-flex items-center rounded-lg border border-transparent px-4 py-2 text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60"
                        [disabled]="isButtonConfigured()"
                        [ngClass]="{
                          'cursor-not-allowed': isButtonConfigured()
                        }"
                      >
                        + Adicionar URL
                      </button>
                    </div>
                  </div>


                  <div
                    class="px-4 pb-4"
                    *ngIf="optionSelectedButton === 'normal'"
                  >
                    <div
                      class="grid grid-cols-1 md:grid-cols-2 gap-3 max-h-48 overflow-y-auto pr-2"
                    >
                      <div
                        *ngFor="let item of objectButtons.buttons; index as i"
                      >
                        <div
                          *ngIf="isObject(item)"
                          class="flex items-center gap-2 rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2"
                        >
                          <input
                            class="w-full px-3 py-2 rounded-md border border-neutral-200 text-sm"
                            type="text"
                            [value]="item.text"
                            [(ngModel)]="objectButtons.buttons[i].text"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Nome do botão"
                          />
                          <button
                            (click)="handleRemoveButton(i)"
                            type="button"
                            aria-label="Remover botão"
                            class="rounded-md px-3 py-1.5 text-xs font-medium bg-rose-100 text-rose-700 hover:bg-rose-200"
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="pt-3">
                      <button
                        *ngIf="validateShowAddButton()"
                        class="rounded-lg w-40 px-3 py-2 bg-blue-600 text-white text-sm hover:bg-blue-700"
                        (click)="handleAddButton()"
                      >
                        + Adicionar Botão
                      </button>
                    </div>
                  </div>


                  <div
                    class="px-4 pb-4"
                    *ngIf="optionSelectedButton === 'lista'"
                  >
                    <div class="flex flex-col gap-3 max-h-48 overflow-y-auto pr-2">
                      <div
                        *ngFor="let item of objectButtons.items; index as i"
                      >
                        <div
                          *ngIf="isObject(item)"
                          class="flex items-center gap-2 rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2"
                        >
                          <input
                            class="w-full px-3 py-2 rounded-md border border-neutral-200 text-sm"
                            type="text"
                            [value]="item.title"
                            [(ngModel)]="objectButtons.items[i].title"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Nome do botão"
                          />
                          <input
                            class="w-full px-3 py-2 rounded-md border border-neutral-200 text-sm"
                            type="text"
                            [value]="item.description"
                            [(ngModel)]="objectButtons.items[i].description"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder=""
                          />
                          <button
                            (click)="handleRemoveItemList(i)"
                            type="button"
                            aria-label="Remover botão"
                            class="rounded-md px-3 py-1.5 text-xs font-medium bg-rose-100 text-rose-700 hover:bg-rose-200"
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="pt-3">
                      <button
                        *ngIf="validateShowAddButtonList()"
                        class="rounded-lg w-40 px-3 py-2 bg-blue-600 text-white text-sm hover:bg-blue-700"
                        (click)="handleAddButton()"
                      >
                        + Adicionar Item
                      </button>
                    </div>
                  </div>


                  <div
                    class="px-4 pb-4"
                    *ngIf="optionSelectedButton === 'url'"
                  >
                    <div class="flex flex-col gap-3 max-h-48 overflow-y-auto pr-2">
                      <div
                        *ngFor="let item of objectButtons.buttons; index as i"
                      >
                        <div
                          *ngIf="isObject(item)"
                          class="flex items-center gap-2 rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2"
                        >
                          <input
                            class="w-full px-3 py-2 rounded-md border border-neutral-200 text-sm"
                            type="text"
                            [value]="item.url"
                            [(ngModel)]="objectButtons.buttons[i].url"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Nome do botão"
                          />
                          <input
                            class="w-full px-3 py-2 rounded-md border border-neutral-200 text-sm"
                            type="text"
                            [value]="item.text"
                            [(ngModel)]="objectButtons.buttons[i].text"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder=""
                          />
                          <button
                            (click)="handleRemoveButtonUrl(i)"
                            type="button"
                            aria-label="Remover botão"
                            class="rounded-md px-3 py-1.5 text-xs font-medium bg-rose-100 text-rose-700 hover:bg-rose-200"
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="pt-3">
                      <button
                        *ngIf="validateShowAddButtonUrl()"
                        class="rounded-lg w-40 px-3 py-2 bg-blue-600 text-white text-sm hover:bg-blue-700"
                        (click)="handleAddButton()"
                      >
                        + Adicionar Item
                      </button>
                    </div>
                  </div>
                </div> -->
              </div>
            </section>

            <footer
              id="footer"
              class="flex justify-end items-center p-6 bg-white border-t border-neutral-200/80 space-x-4"
            >
              <button
                (click)="previousStep()"
                id="cancel_button_3"
                type="button"
                class="px-6 py-2.5 text-sm tracking-wide text-neutral-700 bg-neutral-200/90 border border-transparent rounded-md shadow-sm hover:bg-neutral-300/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-400 transition-all duration-200"
              >
                VOLTAR
              </button>
              <button
                (click)="nextStep()"
                id="continue_button_3"
                type="submit"
                class="px-6 py-2.5 text-sm tracking-wide button-send text-white bg-neutral-900 border border-transparent rounded-md shadow-sm hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-900 transition-all duration-200"
              >
                <i class="fa-solid fa-arrow-right mr-2"></i>CONTINUAR
              </button>
            </footer>
          </form>
        </div>

        <!-- STEP 2 -->
        <div [ngClass]="stepForm === 3 ? 'block' : 'hidden'">
          <form id="import_form" class="space-y-8" [formGroup]="formOficialCsv">
            <section
              id="channels_section"
              class="p-8 flex-grow bg-neutral-50/50"
            >
              <div id="channels_content_block" class="space-y-6">
                <label
                  for="channels_list"
                  class="block text-sm text-neutral-800"
                  >Canais que deseja disparar:
                  <span class="text-neutral-500">*</span></label
                >
                <div
                  id="channels_list"
                  class="border border-neutral-300/90 rounded-lg bg-white shadow-sm"
                  *ngFor="let canal of listChannels"
                >
                  <div class="flex items-center justify-between p-4">
                    <div class="flex items-center space-x-4">
                      <input
                        [id]="canal.idcanal"
                        [value]="canal.idcanal"
                        (change)="handleSelectChannel($event)"
                        [disabled]="canal.status === 'Desconectado'"
                        type="checkbox"
                        class="h-5 w-5 text-neutral-900 border-neutral-400 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200 cursor-pointer"
                      />
                      <label
                        [htmlFor]="canal.idcanal"
                        class="text-sm text-neutral-800"
                        >{{ canal.nomefila }}</label
                      >
                    </div>
                    <div class="flex items-center space-x-2">
                      <div
                        class="w-2.5 h-2.5 rounded-full"
                        [ngClass]="{
                          'bg-green-500': canal.status === 'Conectado',
                          'bg-red-500': canal.status === 'Desconectado'
                        }"
                      ></div>
                      <span
                        class="text-xs uppercase tracking-wider text-neutral-700"
                        >{{ canal.status }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <footer
              id="footer"
              class="flex justify-end items-center p-6 bg-white border-t border-neutral-200/80 space-x-4"
            >
              <button
                (click)="previousStep()"
                id="cancel_button_3"
                type="button"
                class="px-6 py-2.5 text-sm tracking-wide text-neutral-700 bg-neutral-200/90 border border-transparent rounded-md shadow-sm hover:bg-neutral-300/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-400 transition-all duration-200"
              >
                VOLTAR
              </button>
              <button
                (click)="nextStep()"
                id="continue_button_3"
                type="submit"
                class="px-6 py-2.5 text-sm tracking-wide button-send text-white bg-neutral-900 border border-transparent rounded-md shadow-sm hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-900 transition-all duration-200"
              >
                <i class="fa-solid fa-arrow-right mr-2"></i>CONTINUAR
              </button>
            </footer>
          </form>
        </div>

        <div [ngClass]="stepForm === 4 ? 'block' : 'hidden'">
          <form id="import_form" class="space-y-8" [formGroup]="formOficialCsv">
            <section id="scheduling_form_section" class="p-8 flex-grow">
              <div id="personalized_sending_block" class="space-y-4">
                <label class="block text-sm text-neutral-800"
                  >Envio personalizado:
                  <span class="text-neutral-500">*</span></label
                >
                <div class="space-y-4">
                  <div id="schedule_send_option" class="flex items-center">
                    <input
                      (change)="handleIsScheduled($event)"
                      id="schedule_send_checkbox"
                      type="checkbox"
                      class="h-4 w-4 text-neutral-900 border-neutral-300 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200"
                    />
                    <label
                      for="schedule_send_checkbox"
                      class="ml-3 block text-sm text-neutral-700"
                      >Agendar Envio</label
                    >
                    <input
                      formControlName="data"
                      *ngIf="isScheduled"
                      id="schedule_date"
                      type="date"
                      class="ml-3 w-full px-2 py-1 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200"
                    />
                    <input
                      formControlName="horario"
                      *ngIf="isScheduled"
                      id="schedule_time"
                      type="time"
                      class="ml-3 w-full px-2 py-1 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200"
                    />
                  </div>
                  <div id="business_hours_option" class="flex items-center">
                    <input
                      formControlName="hComercial"
                      id="business_hours_checkbox"
                      type="checkbox"
                      class="h-4 w-4 text-neutral-900 border-neutral-300 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200"
                    />
                    <label
                      for="business_hours_checkbox"
                      class="ml-3 block text-sm text-neutral-700"
                      >Disparar somente em horario comercial (08:00 as
                      19:00)</label
                    >
                  </div>
                  <div id="saturday_sending_option" class="flex items-center">
                    <input
                      formControlName="saturday"
                      id="sunday_sending_checkbox"
                      type="checkbox"
                      class="h-4 w-4 text-neutral-900 border-neutral-300 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200"
                    />
                    <label
                      for="sunday_sending_checkbox"
                      class="ml-3 block text-sm text-neutral-700"
                      >Disparar aos Sabados</label
                    >
                  </div>
                  <div id="sunday_sending_option" class="flex items-center">
                    <input
                      formControlName="sunday"
                      id="sunday_sending_checkbox"
                      type="checkbox"
                      class="h-4 w-4 text-neutral-900 border-neutral-300 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200"
                    />
                    <label
                      for="sunday_sending_checkbox"
                      class="ml-3 block text-sm text-neutral-700"
                      >Disparar aos Domingos</label
                    >
                  </div>
                </div>
              </div>
              <div class="border-t border-neutral-200 pt-6">
                <div id="whatsapp_terms_option" class="flex items-center">
                  <input
                    name="acceptTerm"
                    formControlName="acceptTerm"
                    type="checkbox"
                    class="h-4 w-4 text-neutral-900 border-neutral-300 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200"
                    required
                  />
                  <label
                    for="whatsapp_terms_checkbox"
                    class="ml-3 block text-sm text-neutral-700"
                    ><a
                      href="https://www.whatsapp.com/legal/terms-of-service?lang=pt_BR"
                      target="_blank"
                      >Concordo com os Termos do Whatsapp </a
                    ><span class="text-neutral-500">*</span></label
                  >
                </div>
                <div id="whatsapp_terms_option" class="flex items-center">
                  <input
                    name="acceptTermPlataform"
                    formControlName="acceptTermPlataform"
                    (change)="handleShowTerm()"
                    type="checkbox"
                    class="h-4 w-4 text-neutral-900 border-neutral-300 rounded focus:ring-neutral-900 focus:ring-offset-2 transition-all duration-200"
                    required
                  />
                  <label
                    for="whatsapp_terms_checkbox"
                    class="ml-3 block text-sm text-neutral-700"
                    ><a href="/app/termo-disparo-oficial" target="_blank"
                      >Concordo com os Termos da Plataforma</a
                    >
                    <span class="text-neutral-500">*</span></label
                  >
                </div>
              </div>
            </section>
            <footer
              id="footer"
              class="flex justify-end items-center p-6 bg-white border-t border-neutral-200/80 space-x-4"
            >
              <button
                (click)="previousStep()"
                id="cancel_button_3"
                type="button"
                class="px-6 py-2.5 text-sm tracking-wide text-neutral-700 bg-neutral-200/90 border border-transparent rounded-md shadow-sm hover:bg-neutral-300/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-400 transition-all duration-200"
              >
                VOLTAR
              </button>
              <button
                (click)="handleSubmitFire()"
                [disabled]="!handleValidStepThree()"
                id="continue_button_3"
                type="submit"
                class="px-6 py-2.5 text-sm tracking-wide button-send text-white bg-neutral-900 border border-transparent rounded-md shadow-sm hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-900 transition-all duration-200"
              >
                <i class="fa-solid fa-arrow-right mr-2"></i>CONTINUAR
              </button>
            </footer>
          </form>
        </div>
      </section>
    </main>
  </div>
</div>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
